module.exports = __webpack_public_path__ + "img/fondo_control_icons.6e5dee71.png";